import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function VrhIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="VrhIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        //@ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <polygon fill="#FFFFFF" points="50,22.4 26.1,63.8 73.9,63.8 " />
      <polygon fillRule="evenodd" clipRule="evenodd" fill="#FF0000" points="50,30 32.7,60 67.3,60 " />
    </svg>
  </SvgIcon>
}

export default VrhIcon;
